export var UIMessageStatus;
(function (UIMessageStatus) {
    UIMessageStatus[UIMessageStatus["Default"] = 0] = "Default";
    UIMessageStatus[UIMessageStatus["Waiting"] = 1] = "Waiting";
    UIMessageStatus[UIMessageStatus["Accepted"] = 2] = "Accepted";
    UIMessageStatus[UIMessageStatus["Error"] = 3] = "Error";
    UIMessageStatus[UIMessageStatus["Tax"] = 4] = "Tax";
    UIMessageStatus[UIMessageStatus["Purchase"] = 5] = "Purchase";
})(UIMessageStatus || (UIMessageStatus = {}));
//# sourceMappingURL=UIMessageStatus.js.map